import PlayerImage from "../leaderboard/PlayerImage";
import PlayerName from "../leaderboard/PlayerName";
import PlayerRank from "../leaderboard/PlayerRank";
import PlayerScore from "../leaderboard/PlayerScore";
import { ImageToDataURL, SDKManager } from "../lib/SDKManager";
import { BootScene } from "./boot-scene";
import { HUDScene } from "./hud-scene";

export class MenuScene extends Phaser.Scene {
  private bitmapTexts: Phaser.GameObjects.Text[] = [];

  private _banner: Phaser.GameObjects.Image;
  private _title: Phaser.GameObjects.Image;
  private _coinText: Phaser.GameObjects.Text;
  private _coinImage: Phaser.GameObjects.Image;
  private _text1: Phaser.GameObjects.Image;
  private _text2: Phaser.GameObjects.Image;
  // private _tournamentButton: Phaser.GameObjects.Image;
  // private _friendsButton: Phaser.GameObjects.Image;
  // private _watchAdButton: Phaser.GameObjects.Image;
  private _howToPlayButton: Phaser.GameObjects.Image;
  // private _rewardAdCoinText: Phaser.GameObjects.Text;
  // private _rewardAdCoinImage: Phaser.GameObjects.Image;
  // private _shareButton: Phaser.GameObjects.Image;
  private _highlight: Phaser.GameObjects.Sprite;
  private _highLightOffset: number[];

  private _car: Phaser.GameObjects.Image;
  private _carTween: Phaser.Tweens.Tween;
  private _carTween2: Phaser.Tweens.Tween;
  private _titleTween: Phaser.Tweens.Tween;
  private _text1Tween: Phaser.Tweens.Tween;
  private _text2Tween: Phaser.Tweens.Tween;
  private _textTween2: Phaser.Tweens.Tween;
  private _highlightTween: Phaser.Tweens.Tween;

  private _tapToStartText: Phaser.GameObjects.Text;
  private _tapToStartButton: Phaser.GameObjects.Image;

  // private _logo: Phaser.GameObjects.Image;

  private _shopCar: Phaser.GameObjects.Image;
  private _coins: number = 0;
  private _shopPanel: Phaser.GameObjects.Image;
  private _shopText: Phaser.GameObjects.Text;
  private _shopCoin: Phaser.GameObjects.Image;
  private _shopCoinsAvailableText: Phaser.GameObjects.Text;
  private _shopDisplayPanel: Phaser.GameObjects.Image;
  private _shopCarImage: Phaser.GameObjects.Image;
  private _shopPricePanel: Phaser.GameObjects.Image;
  private _shopLeftArrow: Phaser.GameObjects.Image;
  private _shopRightArrow: Phaser.GameObjects.Image;
  private _shopEquipCoinImage: Phaser.GameObjects.Image;
  private _shopCoinsRequired: Phaser.GameObjects.Text;
  private _shop_health_icon: Phaser.GameObjects.Text;
  private _shop_health_level: Phaser.GameObjects.Image[] = [];
  private _shop_health_level_bar: Phaser.GameObjects.Image;
  private _shopEquipButton: Phaser.GameObjects.Image;
  private _shopEquipText: Phaser.GameObjects.Text;
  private _shopCloseButton: Phaser.GameObjects.Image;
  private _shopInsufficientCoinsText: Phaser.GameObjects.Text;
  private _shopCarsButton: Phaser.GameObjects.Image;
  private _shopCarsText: Phaser.GameObjects.Text;
  private _shopMapsButton: Phaser.GameObjects.Image;
  private _shopMapsText: Phaser.GameObjects.Text;
  private _carIndex: number = 0;
  private _mapIndex: number = 0;

  private _canBuy: boolean = false;
  private _canEquip: boolean = false;
  private _onShopCarPanel: boolean = true;
  private _onShopMapPanel: boolean = false;

  private _noActiveTournamentContainer: Phaser.GameObjects.Container;
  private _onTournamentContainer: Phaser.GameObjects.Container;
  private _adWaitingPanelContianer: Phaser.GameObjects.Container;
  private _createTournamentText: Phaser.GameObjects.Text;
  private _createTournamentButton: Phaser.GameObjects.Image;
  private _tournamentCloseButton: Phaser.GameObjects.Image;

  private _howToPlayContainer: Phaser.GameObjects.Container;
  private _howToPlaySprites: string[] = ["howtoplay0", "howtoplay1", "howtoplay2", "howtoplay3", "howtoplay4"];
  private _howToPlayInstructionsText: string[] =
    ["Hold and move sideways\nto move the car",
      "Dodge obstacles, destroy vehicles\nand collect coins",
      "Defeat mini-bosses and\ncollect power-ups",
      "Collect health kits from\nambulances to heal up!",
      "Click the reward button\nto gain 375 coins"];
  private _howToPlayIndex: number = 0;
  private _howToPlayNextButton: Phaser.GameObjects.Image;
  private _howToPlayPreviousButton: Phaser.GameObjects.Image;
  private _howToPlayInstruction: Phaser.GameObjects.Text;
  private _howToPlayImage: Phaser.GameObjects.Image;

  private _audio: Phaser.Sound.BaseSound;
  private _purchasedAudio: Phaser.Sound.BaseSound;

  private _optionSelected: number = 0;
  constructor() {
    super({
      key: "MenuScene"
    });
  }

  init(): void {
    this._noActiveTournamentContainer = null;
    this._onTournamentContainer = null;
    this._adWaitingPanelContianer = null;
    this._howToPlayContainer = null;
    this._audio = null;
    this._purchasedAudio = null;
    this._audio = this.sound.add("bgm", {
      loop: true,
      volume: window.constants["VOLUME"] * 0.45,
    });
    this._audio.play();
    this._purchasedAudio = this.sound.add("coin", {
      loop: false,
      volume: window.constants["VOLUME"] * 1
    });

    this.generateBase64('icon');
    
    SDKManager.getPlayerCarEquippedMetaData();
    window.constants["CAR_CHOOSEN"] = SDKManager.carEquipped;
    this._carIndex = window.constants["CAR_CHOOSEN"];

    SDKManager.getPlayerMapEquippedMetaData();
    window.constants["MAP"] = SDKManager.mapEquipped;
    this._mapIndex = window.constants["MAP"];

    // let coins = localStorage.getItem("hammerplay_rampageroad_coins");
    // if (coins == null)
    //   localStorage.setItem("hammerplay_rampageroad_coins", "0");
    // else
    //   this._coins = Number(coins);
      SDKManager.getPlayerCoinsMetaData();
      this._coins = SDKManager.coins;

    // let carEquipped = localStorage.getItem("hammerplay_rampageroad_car_equipped_status");
    // if (carEquipped == null)
    //   localStorage.setItem("hammerplay_rampageroad_car_equipped_status", `[{"bought": true, "isEquipped": true, "cost": 0}, {"bought": false, "isEquipped": false, "cost": 500}, {"bought": false, "isEquipped": false, "cost": 1000}]`);
    let carEquipped = SDKManager.carEquippedStatus;

    // let mapEquipped = localStorage.getItem("hammerplay_rampageroad_map_equipped_status");
    // if (mapEquipped == null)
    //   localStorage.setItem("hammerplay_rampageroad_map_equipped_status", `[{"bought": true, "isEquipped": true, "cost": 0}, {"bought": false, "isEquipped": false, "cost": 500}, {"bought": false, "isEquipped": false, "cost": 1000}]`);
    let mapEquipped = SDKManager.mapEquippedStatus;

    this.bitmapTexts = [];
    this.input.removeAllListeners();
    this.initRegistry();
    this._createMenuLayout();
    this.events.on("MenuResume", this._resetMenuLayout, this);
    this._createAdWaitingPanel();
    this._createHowToPlayPanel();
    // this.noTournamentPanel();

    window.gameEvents.on("onDisableLoadingScreen", this.disableLoadingScreen.bind(this));

    let h2 = (window.constants["BASE_HEIGHT"]) / 2;
    this._shopPanel = this.add.image(window.constants["BASE_WIDTH"] / 2, h2, 'shop_panel');
    this._shopText = this.add.text(window.constants["BASE_WIDTH"] / 2, h2 - 450, "shop", { fontSize: "90px", fontFamily: 'font_3' });
    this._shopText.setOrigin(0.5);
    this._shopCoin = this.add.image(window.constants["BASE_WIDTH"] - 850, h2 - 590, "assets", 'coin');
    this._shopCoinsAvailableText = this.add.text(window.constants["BASE_WIDTH"] - 800, h2 - 620, `${this._coins}`, { fontSize: "60px", fontFamily: 'font_3' });
    this._shopDisplayPanel = this.add.image(window.constants["BASE_WIDTH"] / 2, h2 + 100, "display_panel");
    this._shopCarImage = this.add.image(window.constants["BASE_WIDTH"] / 2, h2 + 100, "assets", "player_day");
    this._shopPricePanel = this.add.image(window.constants["BASE_WIDTH"] / 2, h2 + 300, "price_panel");
    this._shopLeftArrow = this.add.image(window.constants["BASE_WIDTH"] - 810, h2 + 100, "next_button");
    this._shopLeftArrow.setScale(-1, 1);
    this._shopLeftArrow.addListener("pointerup", function () {
      if (this._onShopCarPanel) {
        if (this._carIndex == 0)
          this._carIndex = 6;
        else
          this._carIndex--;
      } else if (this._onShopMapPanel) {
        if (this._mapIndex == 0)
          this._mapIndex = 2;
        else
          this._mapIndex--;
      }
      this.onDisplayChange();
    }, this);
    this._shopRightArrow = this.add.image(window.constants["BASE_WIDTH"] - 130, h2 + 100, "next_button");
    this._shopRightArrow.setScale(1);
    this._shopRightArrow.addListener("pointerup", function () {
      if (this._onShopCarPanel) {
        if (this._carIndex == 6)
          this._carIndex = 0;
        else
          this._carIndex++;
      } else if (this._onShopMapPanel) {
        if (this._mapIndex == 2)
          this._mapIndex = 0;
        else
          this._mapIndex++;
      }
      this.onDisplayChange();
    }, this);
    this._shopEquipCoinImage = this.add.image(window.constants["BASE_WIDTH"] - 550, h2 + 310, "assets", 'coin');
    this._shopCoinsRequired = this.add.text(window.constants["BASE_WIDTH"] - 500, h2 + 280, "1000", { fontSize: "50px", fontFamily: 'font_3' });
    this._shop_health_icon = this.add.text((window.constants["BASE_WIDTH"] / 2) - 280, h2 + 490, 'health', { fontSize: "40px", fontFamily: 'font_3' });
    this._shop_health_icon.setScale(0.8);
    this._shop_health_level_bar = this.add.image((window.constants["BASE_WIDTH"] / 2) - 140, h2 + 460, "health_level_bar");
    this._shop_health_level[0] = this.add.image((window.constants["BASE_WIDTH"] / 2) - 264, h2 + 460, "health_level");
    this._shop_health_level[1] = this.add.image((window.constants["BASE_WIDTH"] / 2) - 202, h2 + 460, "health_level");
    this._shop_health_level[2] = this.add.image((window.constants["BASE_WIDTH"] / 2) - 140, h2 + 460, "health_level");
    // this._shop_health_level[3] = this.add.image((window.constants["BASE_WIDTH"] / 2) - 138, h2 + 460, "health_level");
    // this._shop_health_level[4] = this.add.image((window.constants["BASE_WIDTH"] / 2) - 76, h2 + 460, "health_level");
    this._shopEquipButton = this.add.image((window.constants["BASE_WIDTH"] / 2) + 200, h2 + 460, "equipped_button");
    this._shopEquipButton.setOrigin(0.5);
    this._shopEquipText = this.add.text((window.constants["BASE_WIDTH"] / 2) + 200, h2 + 460, "equip", { fontSize: "30px", fontFamily: 'font_3' });
    this._shopEquipText.setOrigin(0.5);
    this._shopEquipButton.addListener("pointerup", this.onEquipButton, this);
    this._shopInsufficientCoinsText = this.add.text(window.constants["BASE_WIDTH"] - 750, h2 - 230, "not enough coins", { fontSize: "50px", fontFamily: 'font_3' });
    this._shopCarsButton = this.add.image((window.constants["BASE_WIDTH"] / 2) - 200, h2 - 300, "selected_button");
    this._shopCarsButton.setOrigin(0.5);
    this._shopCarsButton.addListener("pointerup", function () {
      if (!this._onShopCarPanel) {
        SDKManager.getPlayerCarEquippedMetaData();
        SDKManager.getPlayerMapEquippedMetaData();
        this._shopCarsButton.setTexture("selected_button");
        this._shopCarsText.setColor("#ffffff");
        this._shopMapsButton.setTexture("unselected_button");
        this._shopMapsText.setColor("#4880bd");
        this._shopEquipButton.setPosition((window.constants["BASE_WIDTH"] / 2) + 200, h2 + 460);
        this._shopEquipText.setPosition((window.constants["BASE_WIDTH"] / 2) + 200, h2 + 460);
        window.constants["MAP"] = SDKManager.mapEquipped;
        this._mapIndex = window.constants["MAP"];
        this._onShopCarPanel = true;
        this._onShopMapPanel = false;
        this.onDisplayChange();
      }
    }, this);
    this._shopMapsButton = this.add.image((window.constants["BASE_WIDTH"] / 2) + 200, h2 - 300, "unselected_button");
    this._shopMapsButton.setOrigin(0.5);
    this._shopMapsButton.addListener("pointerup", function () {
      if (!this._onShopMapPanel) {
        SDKManager.getPlayerCarEquippedMetaData();
        SDKManager.getPlayerMapEquippedMetaData();
        this._shopMapsButton.setTexture("selected_button");
        this._shopMapsText.setColor("#ffffff");
        this._shopCarsButton.setTexture("unselected_button");
        this._shopCarsText.setColor("#4880bd");
        this._shopEquipButton.setPosition((window.constants["BASE_WIDTH"] / 2), h2 + 460);
        this._shopEquipText.setPosition((window.constants["BASE_WIDTH"] / 2), h2 + 460);
        window.constants["CAR_CHOOSEN"] = SDKManager.carEquipped;
        this._carIndex = window.constants["CAR_CHOOSEN"];
        this._onShopCarPanel = false;
        this._onShopMapPanel = true;
        this.onDisplayChange();
      }
    }, this);
    this._shopCarsText = this.add.text((window.constants["BASE_WIDTH"] / 2) - 210, h2 - 300, "cars", { fontSize: "60px", fontFamily: 'font_3', color: "#ffffff" });
    this._shopCarsText.setOrigin(0.5);
    this._shopMapsText = this.add.text((window.constants["BASE_WIDTH"] / 2) + 210, h2 - 300, "maps", { fontSize: "60px", fontFamily: 'font_3', color: "#4880bd" });
    this._shopMapsText.setOrigin(0.5);
    this._shopCloseButton = this.add.image(window.constants["BASE_WIDTH"] - 120, h2 - 590, "close_button");
    // this._shopCloseButton.setScale(0.5);
    this._shopCloseButton.addListener("pointerup", this.onCloseShopPanel, this);
    this.onShopPanel(false);

    // const onVisibilityChange = () =>{
    //   if(document.hidden){
    //     this.game.sound.mute = true;
    //   }
    //   else{
    //     this.game.sound.mute = false;
    //   }
    // }
    // // document.addEventListener("visibilitychange",onVisibilityChange);
  }

  /** Method to generate Base64 string from texture. */
  private generateBase64(key: string, frame: string = null) {
    let base64 = this.textures.getBase64(key, frame, 'image/png', 0.92);
    // console.log(base64, " - url of the image");
    ImageToDataURL(base64);
    // return base64;
  }

  _createHowToPlayPanel() {
    let w2 = window.constants["BASE_WIDTH"] / 2;
    let h2 = window.constants["BASE_HEIGHT"] / 2;
    this._howToPlayContainer = this.add.container(0, 0);

    let background = this.add.image(w2, h2 - 30, "how_to_play_panel");
    background.setScale(1, 1);
    let text1 = this.add.text(w2, h2 - 630, "how to play", { fontSize: "70px", fontFamily: "font_3" });
    text1.setOrigin(0.5, 0.5);
    this._howToPlayIndex = 0;
    this._howToPlayImage = this.add.image(w2, h2 - 50, this._howToPlaySprites[this._howToPlayIndex]);
    this._howToPlayImage.setOrigin(0.5, 0.5);
    this._howToPlayImage.setScale(0.78);
    this._howToPlayInstruction = this.add.text(w2, h2 + 510, this._howToPlayInstructionsText[this._howToPlayIndex], { fontSize: "50px", fontFamily: 'font_2', align: "center" });
    this._howToPlayInstruction.setOrigin(0.5, 0.5);
    this._howToPlayNextButton = this.add.image(window.constants["BASE_WIDTH"] - 120, h2 - 40, "next_button");
    this._howToPlayNextButton.setScale(0.8);
    this._howToPlayNextButton.addListener("pointerup", function () {
      this._howToPlayIndex++;
      this.onChangeHowToPlayInstruction();
    }, this);
    this._howToPlayNextButton.setInteractive();
    this._howToPlayPreviousButton = this.add.image(window.constants["BASE_WIDTH"] - 820, h2 - 40, "next_button");
    this._howToPlayPreviousButton.setScale(-0.8, 0.8);
    this._howToPlayPreviousButton.addListener("pointerup", function () {
      this._howToPlayIndex--;
      this.onChangeHowToPlayInstruction();
    }, this);
    this._howToPlayPreviousButton.disableInteractive();
    this._howToPlayPreviousButton.setAlpha(0.5);
    // let closeButton = this.add.image(window.constants["BASE_WIDTH"] - 110, h2 - 735, "close_button");
    let closeButton = this.add.image(window.constants["BASE_WIDTH"] - 110, text1.y, "close_button");
    closeButton.setScale(0.8);
    closeButton.addListener("pointerup", this.onCloseHowToPlayPanel, this);
    closeButton.setInteractive();
    this._howToPlayContainer.add([background, text1, this._howToPlayImage, this._howToPlayInstruction, this._howToPlayNextButton, this._howToPlayPreviousButton, closeButton]);
    this._howToPlayContainer.setVisible(false);
    this._howToPlayContainer.setActive(false);
    this._howToPlayContainer.setDepth(30);
  }

  onChangeHowToPlayInstruction() {
    if (this._howToPlayIndex == 0) {
      this._howToPlayPreviousButton.disableInteractive();
      this._howToPlayPreviousButton.setAlpha(0.5);
      this._howToPlayNextButton.setInteractive();
      this._howToPlayNextButton.setAlpha(1);
    } else if (this._howToPlayIndex == 3) { // Reset to 4.
      this._howToPlayNextButton.disableInteractive();
      this._howToPlayNextButton.setAlpha(0.5);
      this._howToPlayPreviousButton.setInteractive();
      this._howToPlayPreviousButton.setAlpha(1);
    } else {
      this._howToPlayNextButton.setInteractive();
      this._howToPlayNextButton.setAlpha(1);
      this._howToPlayPreviousButton.setInteractive();
      this._howToPlayPreviousButton.setAlpha(1);
    }

    this._howToPlayImage.setTexture(this._howToPlaySprites[this._howToPlayIndex]);
    this._howToPlayInstruction.setText(this._howToPlayInstructionsText[this._howToPlayIndex]);
  }

  onShowHowToPlayPanel(show: boolean) {
    this._howToPlayIndex = 0;
    this.onChangeHowToPlayInstruction();
    this._howToPlayContainer.setVisible(show);
    this._howToPlayContainer.setActive(show);
    this._howToPlayContainer.setDepth(30);

    // this._tournamentButton.setInteractive();
    this._tapToStartButton.setInteractive();
    // this._friendsButton.setInteractive();
    // this._watchAdButton.setInteractive();
    this._howToPlayButton.setInteractive();
    this._shopCar.setInteractive();
    // this._tournamentButton.visible = !show;
    this._title.visible = !show;
    this._car.visible = !show;
    // this._friendsButton.visible = !show;
    // this._watchAdButton.visible = !show;
    this._howToPlayButton.visible = !show;
    // this._rewardAdCoinText.visible = !show;
    // this._rewardAdCoinImage.visible = !show;
    this._coinText.visible = !show;
    this._coinText.setText(`${SDKManager.coins}`);
    this._coinImage.visible = !show;
    this._shopCar.visible = !show;
    this._tapToStartButton.visible = !show;
    this._tapToStartText.visible = !show;
  }

  onCloseHowToPlayPanel() {
    this.onShowHowToPlayPanel(false);
  }

  private onDisplayChange() {
    this._shopInsufficientCoinsText.visible = false;
    if (this._onShopCarPanel) {
      this._shop_health_level_bar.visible = true;
      this._shop_health_icon.visible = true;
      this._shopCarImage.setScale(1.7);
      // this._shopCarImage.setTexture("assets", "player_day");
      switch (this._carIndex) {
        case 0:
          this._shopCarImage.setTexture("assets", "player_day");
          for (let i = 0; i < this._shop_health_level.length; i++)
            this._shop_health_level[i].visible = false;
          this.setEquipStatus(0);
          break;
        case 1:
          this._shopCarImage.setTexture("car_01");
          this._shop_health_level[0].visible = true;
          for (let i = 1; i < this._shop_health_level.length; i++)
            this._shop_health_level[i].visible = false;
          this.setEquipStatus(1);
          break;
        case 2:
          this._shopCarImage.setTexture("car_02");
          this._shop_health_level[0].visible = true;
          for (let i = 1; i < this._shop_health_level.length; i++)
            this._shop_health_level[i].visible = false;
          this.setEquipStatus(2);
          break;
        case 3:
          this._shopCarImage.setTexture("car_03");
          for (let i = 0; i < this._shop_health_level.length - 1; i++)
            this._shop_health_level[i].visible = true;
          this._shop_health_level[this._shop_health_level.length - 1].visible = false;
          this.setEquipStatus(3);
          break;
        case 4:
          this._shopCarImage.setTexture("car_04");
          for (let i = 0; i < this._shop_health_level.length - 1; i++)
            this._shop_health_level[i].visible = true;
          this._shop_health_level[this._shop_health_level.length - 1].visible = false;
          this.setEquipStatus(4);
          break;
        case 5:
          this._shopCarImage.setTexture("car_05");
          for (let i = 0; i < this._shop_health_level.length; i++)
            this._shop_health_level[i].visible = true;
          this.setEquipStatus(5);
          break;
        case 6:
          this._shopCarImage.setTexture("car_06");
          for (let i = 0; i < this._shop_health_level.length; i++)
            this._shop_health_level[i].visible = true;
          this.setEquipStatus(6);
          break;
      }
    } else if (this._onShopMapPanel) {
      this._shop_health_level_bar.visible = false;
      this._shop_health_icon.visible = false;
      for (let i = 0; i < this._shop_health_level.length; i++)
        this._shop_health_level[i].visible = false;
      this._shopCarImage.setScale(0.35);
      this._shopCarImage.clearTint();
      switch (this._mapIndex) {
        case 0:
          this._shopCarImage.setTexture("assets", 'road');
          this.setEquipStatus(0);
          break;
        case 1:
          this._shopCarImage.setTexture("desert");
          this.setEquipStatus(1);
          break;
        case 2:
          this._shopCarImage.setTexture("snow");
          this.setEquipStatus(2);
          break;
      }
    }
  }

  setEquipStatus(index: number) {
    let equippedList;

    if (this._onShopCarPanel) {
      SDKManager.getPlayerCarEquippedStatusMetaData();
      equippedList = SDKManager.carEquippedStatus;
      // equipped = localStorage.getItem("hammerplay_rampageroad_car_equipped_status");
      // equippedList = JSON.parse(equipped);
    } else if (this._onShopMapPanel) {
      SDKManager.getPlayerMapEquippedStatusMetaData();
      equippedList = SDKManager.mapEquippedStatus;
      // equipped = localStorage.getItem("hammerplay_rampageroad_map_equipped_status");
      // equippedList = JSON.parse(equipped);
    }

    if (equippedList[index]["isEquipped"]) {
      // equipped
      this._canEquip = true;
      this._canBuy = false;
      this._shopPricePanel.visible = false;
      this._shopEquipCoinImage.visible = false;
      this._shopCoinsRequired.visible = false;
      this._shopEquipButton.setTexture("equipped_button");
      this._shopEquipText.setText("equipped");
      this._shopEquipText.setFontSize(30);
      this._shopEquipText.setColor("#ffffff");
      // this._shopEquipText.setPosition(window.constants["BASE_WIDTH"] - 640, window.constants["BASE_HEIGHT"] - 300);
    } else {
      // not equipped
      if (equippedList[index]["bought"]) {
        this._canEquip = true;
        this._canBuy = false;
        this._shopPricePanel.visible = false;
        this._shopEquipCoinImage.visible = false;
        this._shopCoinsRequired.visible = false;
        this._shopEquipButton.setTexture("equip_button");
        this._shopEquipText.setText("equip");
        this._shopEquipText.setFontSize(40);
        this._shopEquipText.setColor("#ffffff");
        // this._shopEquipText.setPosition(window.constants["BASE_WIDTH"] - 575, window.constants["BASE_HEIGHT"] - 300);
      } else {
        this._canEquip = false;
        this._shopPricePanel.visible = true;
        this._shopEquipCoinImage.visible = true;
        this._shopCoinsRequired.visible = true;
        this._shopCoinsRequired.setText(equippedList[index]["cost"]);
        this._shopEquipText.setText("buy");
        this._shopEquipText.setFontSize(40);
        // this._shopEquipText.setPosition(window.constants["BASE_WIDTH"] - 535, window.constants["BASE_HEIGHT"] - 300);
        if (this._coins >= equippedList[index]["cost"]) {
          this._canBuy = true;
          this._shopEquipButton.setTexture("buy_button");
        } else {
          this._canBuy = false;
          this._shopEquipButton.setTexture("insufficient_coins_button");
        }
      }
    }
  }

  onEquipButton() {
    if (this._onShopCarPanel) {
      SDKManager.getPlayerCarEquippedStatusMetaData();
      let equippedList = SDKManager.carEquippedStatus;
      // let equipped = localStorage.getItem("hammerplay_rampageroad_car_equipped_status");
      // let equippedList = JSON.parse(equipped);
      if (this._canEquip) {
        window.constants["CAR_CHOOSEN"] = this._carIndex;
        // localStorage.setItem("hammerplay_rampageroad_car_equipped", `${this._carIndex}`);
        SDKManager.setPlayerCarEquippedMetaData(this._carIndex);
        for (let index = 0; index < equippedList.length; index++) {
          if (index == this._carIndex) {
            equippedList[index]["isEquipped"] = true;
          } else {
            equippedList[index]["isEquipped"] = false;
          }
        }
      } else {
        if (this._canBuy) {
          this._purchasedAudio.play();
          this._coins -= equippedList[this._carIndex]["cost"];
          // localStorage.setItem("hammerplay_rampageroad_coins", `${this._coins}`);
          SDKManager.setPlayerCoinsMetaData(this._coins);
          this._shopCoinsAvailableText.setText(`${this._coins}`);
          equippedList[this._carIndex]["bought"] = true;
        } else {
          this._shopInsufficientCoinsText.visible = true;
        }
      }
      // localStorage.setItem("hammerplay_rampageroad_car_equipped_status", JSON.stringify(equippedList));
      SDKManager.setPlayerCarEquippedStatusMetaData(equippedList);
      this.setEquipStatus(this._carIndex);
    } else if (this._onShopMapPanel) {
      SDKManager.getPlayerMapEquippedStatusMetaData();
      let equippedList = SDKManager.mapEquippedStatus;
      // let equipped = localStorage.getItem("hammerplay_rampageroad_map_equipped_status");
      // let equippedList = JSON.parse(equipped);
      if (this._canEquip) {
        window.constants["MAP"] = this._mapIndex;
        // localStorage.setItem("hammerplay_rampageroad_map_equipped", `${this._mapIndex}`);
        SDKManager.setPlayerMapEquippedMetaData(this._mapIndex);
        for (let index = 0; index < equippedList.length; index++) {
          if (index == this._mapIndex) {
            equippedList[index]["isEquipped"] = true;
          } else {
            equippedList[index]["isEquipped"] = false;
          }
        }
      } else {
        if (this._canBuy) {
          this._purchasedAudio.play();
          this._coins -= equippedList[this._mapIndex]["cost"];
          // localStorage.setItem("hammerplay_rampageroad_coins", `${this._coins}`);
          SDKManager.setPlayerCoinsMetaData(this._coins);
          this._shopCoinsAvailableText.setText(`${this._coins}`);
          equippedList[this._mapIndex]["bought"] = true;
        } else {
          this._shopInsufficientCoinsText.visible = true;
        }
      }
      // localStorage.setItem("hammerplay_rampageroad_map_equipped_status", JSON.stringify(equippedList));
      SDKManager.setPlayerMapEquippedStatusMetaData(equippedList);
      this.setEquipStatus(this._mapIndex);
    }
  }

  private _onKeyUp(e) {
    if (e.which == 53 || e.keyCode == 53 || e.which == 13 || e.keyCode == 13) {
      window.constants["TOUCH_FLAG"] = false;
      this.input.removeAllListeners();
      this.changeScene();
    }
  }

  private _onTouchUp(e) {
    this.input.removeAllListeners();
    window.constants["TOUCH_FLAG"] = true;
    this.changeScene();
  }

  private _createMenuLayout() {
    this._optionSelected = 0;
    let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
    let banner = this.textures.getFrame("assets", "menu_banner");
    let scaleX = window.constants["BASE_WIDTH"] / banner.width;
    let scaleY = window.constants["BASE_HEIGHT"] / banner.height;
    this._banner = this.add.image(w2, h2, "assets", "menu_banner");
    this._banner.setScale(scaleX, scaleY);
    this._car = this.add.image(0, 0, "assets", "title_car");
    this._car.setScale(scaleX);
    this._title = this.add.image(0, 0, "assets", "menu_title");
    this._title.setScale(scaleX);
    this._title.setScale(scaleX);
    this._coinText = this.add.text(0, 0, `${this._coins}`, { fontSize: "50px", fontFamily: 'font_3', color: "#ffffff" });
    this._coinImage = this.add.image(0, 0, "assets", 'coin');
    this._coinImage.setOrigin(0.5);
    // this._tournamentButton = this.add.image(0, 0, "tournament_button");
    // this._tournamentButton.setScale(0.9);
    // this._friendsButton = this.add.image(0, 0, "invite_friends_button");
    // this._friendsButton.setScale(0.9);
    // this._watchAdButton = this.add.image(0, 0, "watch_ad_button");
    // this._watchAdButton.setScale(0.9);
    this._howToPlayButton = this.add.image(0, 0, "how_to_play_button");
    this._howToPlayButton.setScale(0.9);
    // this._rewardAdCoinText = this.add.text(0, 0, "375", { fontSize: "45px", fontFamily: 'font_3', color: "#ffffff" });
    // this._rewardAdCoinText.setOrigin(0.5);
    // this._rewardAdCoinImage = this.add.image(0, 0, "assets", 'coin');
    // this._rewardAdCoinImage.setOrigin(0.5);
    // this._rewardAdCoinImage.setScale(0.7);
    this._shopCar = this.add.image(0, 0, 'shop_button');
    this._shopCar.setScale(0.9);
    this._shopCar.visible = false;

    this._title.setPosition(w2, -this._title.height);
    this._car.setPosition(w2, -this._car.height);
    this._coinText.setPosition(w2 - 350, this._title.y + ((-this._title.y) + 400));
    this._coinImage.setPosition(this._coinText.x - 40, this._coinText.y + 25);
    this._shopCar.setPosition(w2 + 275, h2 * 1.4);
    // this._tournamentButton.setPosition(w2 - 275, h2 * 1.4);
    // this._friendsButton.setPosition(w2 + 275, h2 * 1.4);
    // this._watchAdButton.setPosition(w2 + 275, h2 * 1.2);
    this._howToPlayButton.setPosition(w2 - 275, h2 * 1.4);
    // this._rewardAdCoinText.setPosition(this._watchAdButton.x + 30, this._watchAdButton.y + 50);
    // this._rewardAdCoinImage.setPosition(this._rewardAdCoinText.x - 80, this._rewardAdCoinText.y - 1.5);
    // this._tournamentButton.visible = false;
    // this._friendsButton.visible = false;
    // this._watchAdButton.visible = false;
    this._howToPlayButton.visible = false;
    // this._rewardAdCoinText.visible = false;
    // this._rewardAdCoinImage.visible = false;
    this._coinText.visible = false;
    this._coinText.setText(`${SDKManager.coins}`);
    this._coinImage.visible = false;

    this._tapToStartButton = this.add.image(0, 0, 'play_button');
    this._tapToStartButton.setOrigin(0.5);
    this._tapToStartButton.setPosition(w2, h2 * 1.65);
    this._tapToStartButton.visible = false;

    this._tapToStartText = this.add.text(0, 0, "Tap To Start",
      { fontSize: "50px", fontFamily: 'font_3', color: "#ae4300" }
    );
    this._tapToStartText.setOrigin(0.5);
    this._tapToStartText.setPosition(w2, h2 * 1.65);
    this._tapToStartText.visible = false;

    this._shopCar.addListener("pointerup", this.onShopPanel, this);

    this._tapToStartButton.addListener("pointerup", this.onTapToStart, this);
    // this._tournamentButton.addListener("pointerup", function () {
    //   this.tournamentPanel();
    // }, this);

    // this._friendsButton.addListener("pointerup", function () {
    //   FBInstantManager.inviteFriend(`${FBInstant.player.getName()} wants you to join them in this game!`);
    // }, this);

    // this._watchAdButton.addListener("pointerup", async function () {
    //   window.game.sound.mute = true;
    //   SDKManager.getPlayerCoinsMetaData();
    //   this._showLoadingScreen(true);
    //   if (await FBInstantManager.showCoinsVideoAd()) {
    //     // console.log("coin ad");
    //     let coins = SDKManager.coins;
    //     coins += 375;
    //     SDKManager.setPlayerCoinsMetaData(coins);
    //     this._coinText.setText(`${SDKManager.coins}`);
    //     this.time.delayedCall(500, () => {
    //       this._coinText.setText(`${SDKManager.coins}`);
    //     });
    //   }
    // }, this);

    this._howToPlayButton.addListener("pointerup", function () {
      this.onShowHowToPlayPanel(true);
    }, this);

    this._createTweens();
    window.setTimeout(this._startMenuTween.bind(this), 500);
    window.constants["TOUCH_FLAG"] = true;
  }

  private tournamentPanel() {
    this._showLoadingScreen(true);
    // this.onTournamentOpenButton();
    this._tournamentCloseButton = this.add.image((window.constants["BASE_WIDTH"] / 2) + 350, (window.constants["BASE_HEIGHT"] / 2) - 590, "close_button");
    // this._tournamentCloseButton.setScale(0.6, 0.6);
    this._tournamentCloseButton.addListener("pointerup", function () {
      // if (FBInstantManager.isTournament) {
      //   this.clearTextures();
      //   this._onTournamentContainer.setVisible(false);
      //   this._onTournamentContainer.setActive(false);
      //   this._onTournamentContainer.setDepth(30);
      //   this._onTournamentContainer = null;
      // }
      // this._noActiveTournamentContainer.setVisible(false);
      // this._noActiveTournamentContainer.setActive(false);
      // this._noActiveTournamentContainer.setDepth(30);
      // this.onTournamentCloseButton();
    }, this);

    // if (FBInstantManager.isTournament) {
    //   this.time.delayedCall(1000, () => {
    //     this.tournamentActivePanel();
    //   });
    // } else {
    //   this.time.delayedCall(500, () => {
    //     this._showLoadingScreen(false);
    //     this._tournamentCloseButton.setInteractive();
    //     this._createTournamentButton.setInteractive();
    //     this._noActiveTournamentContainer.setVisible(true);
    //     this._noActiveTournamentContainer.setActive(true);
    //     this._noActiveTournamentContainer.setDepth(30);
    //   });
    // }
  }

  clearTextures() {
    this.textures.remove("player-profile-pic");
    for (let i = 0; i < 5; i++) {
      // console.log("clear texture ", i);
      this.textures.remove(`player-profile-pic-${i}`);
    }
  }

  // noTournamentPanel() {
  //   let w2 = window.constants["BASE_WIDTH"] / 2;
  //   let h2 = window.constants["BASE_HEIGHT"] / 2;
  //   this._noActiveTournamentContainer = this.add.container(0, 0);

  //   let background = this.add.image(w2, h2, "tournament_panel");
  //   // background.setScale(2, 2);
  //   let text1 = this.add.text(w2, h2 - 450, "tournament", { fontSize: "70px", fontFamily: "font_3" });
  //   text1.setOrigin(0.5, 0.5);
  //   let tournamentText = this.add.text(w2, h2 - 100, "no active tournament", { fontSize: "50px", fontFamily: 'font_3' });
  //   tournamentText.setAlign("center");
  //   tournamentText.setOrigin(0.5, 0.5);
  //   this._createTournamentButton = this.add.image(w2, h2 + 200, "create_tournament_button");
  //   this._createTournamentText = this.add.text(w2, h2 + 200, "create tournament", { fontSize: "45px", fontFamily: 'font_3' });
  //   this._createTournamentText.setOrigin(0.5, 0.5);
  //   this._createTournamentButton.setOrigin(0.5, 0.5);
  //   this._createTournamentButton.addListener("pointerup", function () {
  //     this._noActiveTournamentContainer.setVisible(false);
  //     this._noActiveTournamentContainer.setActive(false);
  //     this._noActiveTournamentContainer.setDepth(30);
  //     this.onTournamentCloseButton();
  //     this._showLoadingScreen(true);
  //     // FBInstantManager.createTournament();
  //   }, this);
  //   this._createTournamentButton.setInteractive();
  //   this._noActiveTournamentContainer.add([background, text1, tournamentText, this._createTournamentButton, this._createTournamentText]);
  //   this._noActiveTournamentContainer.setVisible(false);
  //   this._noActiveTournamentContainer.setActive(false);
  //   this._noActiveTournamentContainer.setDepth(30);
  // }

  disableLoadingScreen() {
    if (window.game.sound.volume == 1)
      window.game.sound.mute = false;
    this._showLoadingScreen(false);
  }

  // private playerProfilePic: Phaser.GameObjects.Image[] = [];
  // private playerProfilePosY: number = 650;
  // private profilePosY: number = 800;
  // tournamentActivePanel() {
  //   let w2 = window.constants["BASE_WIDTH"] / 2;
  //   let h2 = window.constants["BASE_HEIGHT"] / 2;
  //   this._onTournamentContainer = this.add.container(0, 0);

  //   let playerBg: Phaser.GameObjects.Image[] = [];
  //   let playerRank: Phaser.GameObjects.Text[] = [];
  //   let playerName: Phaser.GameObjects.Text[] = [];
  //   let playerScore: Phaser.GameObjects.Text[] = [];

  //   let fontSize = (window.constants.HD_FLAG) ? 63 : 14;

  //   let background = this.add.image(w2, h2, "tournament_panel");
  //   // background.setScale(2, 2);
  //   let text1 = this.add.text(w2, h2 - 450, "tournament", { fontSize: "70px", fontFamily: "font_3" });
  //   text1.setOrigin(0.5, 0.5);
  //   let tournamentEndText = this.add.text(w2, h2 - 300, `ends on`, { fontSize: "30px", fontFamily: "font_3" });
  //   tournamentEndText.setOrigin(0.5, 0.5);
  //   tournamentEndText.text = "Ends on " + FBInstantManager.tournamentEndDate;

  //   this._onTournamentContainer.add([background, text1]);
  //   this._onTournamentContainer.add(tournamentEndText);

  //   this.loadPlayersProfilePic();

  //   let playerDetails = FBInstantManager.playerLeaderboardEntry.getPlayer();

  //   // this.loadPlayersProfilePic(playerDetails.getPhoto());

  //   let playerPosY = tournamentEndText.y + 100;
  //   this.playerProfilePosY = playerPosY;
  //   playerBg[0] = this.add.image(w2, playerPosY, "players_rank_bg");
  //   playerBg[0].setOrigin(0.5);
  //   // playerRank[0] = new PlayerRank(this, 200, playerPosY, "1", { fontSize: "40px", fontFamily: "font_2" });
  //   // playerName[0] = new PlayerName(this, 330, playerPosY - 20, "hema", { fontSize: "40px", fontFamily: "font_2" });
  //   // playerScore[0] = new PlayerScore(this, 680, playerPosY, "100", { fontSize: "40px", fontFamily: "font_2" });
  //   playerRank[0] = new PlayerRank(this, 200, playerPosY, `${FBInstantManager.playerLeaderboardEntry.getRank()}`, { fontSize: "40px", fontFamily: "font_2", color: "#b3dcfc" });
  //   playerName[0] = new PlayerName(this, 330, playerPosY - 20, playerDetails.getName(), { fontSize: "40px", fontFamily: "font_2" });
  //   playerScore[0] = new PlayerScore(this, 680, playerPosY, `${FBInstantManager.playerLeaderboardEntry.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //   this._onTournamentContainer.add(playerBg[0]);
  //   this._onTournamentContainer.add(playerRank[0]);
  //   this._onTournamentContainer.add(playerName[0]);
  //   this._onTournamentContainer.add(playerScore[0]);

  //   let posY = playerPosY + 150;
  //   this.profilePosY = posY;

  //   playerBg[1] = this.add.image(w2, posY, "players_rank_bg");
  //   playerBg[1].setOrigin(0.5);
  //   playerBg[1].visible = false;
  //   playerBg[2] = this.add.image(w2, posY + 125, "players_rank_bg");
  //   playerBg[2].setOrigin(0.5);
  //   playerBg[2].visible = false;
  //   playerBg[3] = this.add.image(w2, posY + 250, "players_rank_bg");
  //   playerBg[3].setOrigin(0.5);
  //   playerBg[3].visible = false;
  //   playerBg[4] = this.add.image(w2, posY + 375, "players_rank_bg");
  //   playerBg[4].setOrigin(0.5);
  //   playerBg[4].visible = false;
  //   playerBg[5] = this.add.image(w2, posY + 500, "players_rank_bg");
  //   playerBg[5].setOrigin(0.5);
  //   playerBg[5].visible = false;

  //   FBInstantManager.allLeaderboardEntries.forEach((player, index) => {
  //     if (index > 4)
  //       return;

  //     let otherPlayerDetails = player.getPlayer();
  //     playerBg[index + 1].visible = true;

  //     if (playerDetails.getName() == otherPlayerDetails.getName()) {
  //       // this.loadPlayersProfilePic(playerDetails.getPhoto());
  //       playerRank[index + 1] = new PlayerRank(this, 200, posY + (125 * index), `${FBInstantManager.playerLeaderboardEntry.getRank()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       playerName[index + 1] = new PlayerName(this, 330, (posY - 20) + (125 * index), playerDetails.getName(), { fontSize: "40px", fontFamily: "font_2" });
  //       playerScore[index + 1] = new PlayerScore(this, 680, posY + (125 * index), `${FBInstantManager.playerLeaderboardEntry.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //     } else {
  //       playerRank[index + 1] = new PlayerRank(this, 200, posY + (125 * index), `${player.getRank()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       // this.loadPlayersProfilePic(otherPlayerDetails.getPhoto());
  //       playerName[index + 1] = new PlayerName(this, 330, (posY - 20) + (125 * index), `${otherPlayerDetails.getName()}`, { fontSize: "40px", fontFamily: "font_2" });
  //       playerScore[index + 1] = new PlayerScore(this, 680, posY + (125 * index), `${player.getScore()}`, { fontSize: "40px", fontFamily: "font_2" });
  //     }
  //     this._onTournamentContainer.add(playerBg[index + 1]);
  //     this._onTournamentContainer.add(playerRank[index + 1]);
  //     this._onTournamentContainer.add(playerName[index + 1]);
  //     this._onTournamentContainer.add(playerScore[index + 1]);
  //   });

  //   // for (let i = 0; i < 5; i++) {
  //   //   playerBg[i + 1].visible = true;
  //   //   playerRank[i + 1] = new PlayerRank(this, 200, posY + (125 * i), "1", { fontSize: "40px", fontFamily: "font_2" });
  //   //   playerName[i + 1] = new PlayerName(this, 330, (posY - 20) + (125 * i), "hema", { fontSize: "40px", fontFamily: "font_2" });
  //   //   playerScore[i + 1] = new PlayerScore(this, 680, posY + (125 * i), "100", { fontSize: "40px", fontFamily: "font_2" });
  //   //   this._onTournamentContainer.add(playerBg[i + 1]);
  //   //   this._onTournamentContainer.add(playerRank[i + 1]);
  //   //   this._onTournamentContainer.add(playerName[i + 1]);
  //   //   this._onTournamentContainer.add(playerScore[i + 1]);
  //   // }

  //   this.time.delayedCall(1000, () => {
  //     this._showLoadingScreen(false);
  //     this._tournamentCloseButton.setInteractive();

  //     this._onTournamentContainer.setVisible(true);
  //     this._onTournamentContainer.setActive(true);
  //     this._onTournamentContainer.setDepth(30);
  //   })
  // }

  // onTournamentCloseButton() {
  //   this._tournamentCloseButton.disableInteractive();
  //   this._createTournamentButton.disableInteractive();

  //   this._banner.setInteractive();
  //   // this._tournamentButton.setInteractive();
  //   // this._friendsButton.setInteractive();
  //   // this._watchAdButton.setInteractive();
  //   this._howToPlayButton.setInteractive();
  //   this._shopCar.setInteractive();
  //   this._title.visible = true;
  //   this._car.visible = true;
  //   // this._tournamentButton.visible = true;
  //   // this._friendsButton.visible = true;
  //   // this._watchAdButton.visible = true;
  //   this._howToPlayButton.visible = true;
  //   // this._rewardAdCoinText.visible = true;
  //   // this._rewardAdCoinImage.visible = true;
  //   this._coinText.visible = true;
  //   this._coinText.setText(`${SDKManager.coins}`);
  //   this._coinImage.visible = true;
  //   this._shopCar.visible = true;
  //   this._tapToStartButton.visible = true;
  //   this._tapToStartText.visible = true;
  //   this._tournamentCloseButton.visible = false;
  // }

  // onTournamentOpenButton() {
  //   this._banner.disableInteractive();
  //   // this._tournamentButton.disableInteractive();
  //   // this._friendsButton.disableInteractive();
  //   // this._watchAdButton.disableInteractive();
  //   this._howToPlayButton.disableInteractive();
  //   this._shopCar.disableInteractive();
  //   this._title.visible = false;
  //   this._car.visible = false;
  //   // this._tournamentButton.visible = false;
  //   // this._friendsButton.visible = false;
  //   // this._watchAdButton.visible = false;
  //   this._howToPlayButton.visible = false;
  //   // this._rewardAdCoinText.visible = false;
  //   // this._rewardAdCoinImage.visible = false;
  //   this._coinText.visible = false;
  //   this._coinText.setText(`${SDKManager.coins}`);
  //   this._coinImage.visible = false;
  //   this._shopCar.visible = false;
  //   this._tapToStartButton.visible = false;
  //   this._tapToStartText.visible = false;
  // }

  // loadPlayersProfilePic() {
  //   let playerDetails = FBInstantManager.playerLeaderboardEntry.getPlayer();
  //   this.load.image(`player-profile-pic`, playerDetails.getPhoto());
  //   this.load.once(`filecomplete-image-player-profile-pic`, this.getPlayerPhoto, this);
  //   // console.log(playerDetails.getName());

  //   FBInstantManager.allLeaderboardEntries.forEach((player, index) => {
  //     if (index > 4)
  //       return;

  //     let otherPlayerDetails = player.getPlayer();

  //     if (playerDetails.getName() == otherPlayerDetails.getName()) {
  //       this.load.image(`player-profile-pic-${index}`, playerDetails.getPhoto());
  //       this.load.once(`filecomplete-image-player-profile-pic-${index}`, this.getPlayerPhoto, this);
  //     } else {
  //       this.load.image(`player-profile-pic-${index}`, otherPlayerDetails.getPhoto());
  //       this.load.once(`filecomplete-image-player-profile-pic-${index}`, this.getPlayerPhoto, this);
  //     }
  //     // console.log(otherPlayerDetails.getName());
  //   });
  //   this.load.start();
  // }

  // getPlayerPhoto(key: any) {
  //   // console.log(key);
  //   switch (key) {
  //     case "player-profile-pic":
  //       this.playerProfilePic[0] = new PlayerImage(this, 280, this.playerProfilePosY, "player-profile-pic");
  //       this._onTournamentContainer.add(this.playerProfilePic[0]);
  //       break;
  //     case "player-profile-pic-0":
  //       this.playerProfilePic[1] = new PlayerImage(this, 280, this.profilePosY, "player-profile-pic-0");
  //       this._onTournamentContainer.add(this.playerProfilePic[1]);
  //       break;
  //     case "player-profile-pic-1":
  //       this.playerProfilePic[2] = new PlayerImage(this, 280, this.profilePosY + 125, "player-profile-pic-1");
  //       this._onTournamentContainer.add(this.playerProfilePic[2]);
  //       break;
  //     case "player-profile-pic-2":
  //       this.playerProfilePic[3] = new PlayerImage(this, 280, this.profilePosY + 250, "player-profile-pic-2");
  //       this._onTournamentContainer.add(this.playerProfilePic[3]);
  //       break;
  //     case "player-profile-pic-3":
  //       this.playerProfilePic[4] = new PlayerImage(this, 280, this.profilePosY + 375, "player-profile-pic-3");
  //       this._onTournamentContainer.add(this.playerProfilePic[4]);
  //       break;
  //     case "player-profile-pic-4":
  //       this.playerProfilePic[5] = new PlayerImage(this, 280, this.profilePosY + 500, "player-profile-pic-4");
  //       this._onTournamentContainer.add(this.playerProfilePic[5]);
  //       break;
  //   }
  // }

  private _createAdWaitingPanel() {

    let w2 = window.constants["BASE_WIDTH"] / 2, h2 = window.constants["BASE_HEIGHT"] / 2;

    this._adWaitingPanelContianer = this.add.container(w2, h2);
    this._adWaitingPanelContianer.setDepth(40);
    let dataContainer = this.add.container(0, 0);

    let fontSize = (window.constants["HD_FLAG"]) ? 60 : 14;

    //text
    let text = this.add.text(0, 0, "loading...", { fontSize: fontSize, fontFamily: "font_3", align: "center" });
    text.setOrigin(0.5, 0.5);

    let spinner = this.add.image(0, 0, "spinner");
    let spinnerTween = null;

    text.setPosition(text.x, text.y - 150);

    let rectangle = this.add.rectangle(0, 0, window.constants["BASE_WIDTH"], window.constants["BASE_HEIGHT"], 0x000000, 1);

    dataContainer.add([spinner, text]);
    this._adWaitingPanelContianer.add(rectangle);
    this._adWaitingPanelContianer.add(dataContainer);

    spinnerTween = this.tweens.addCounter({
      from: 0,
      to: 360,
      duration: 3000,
      repeat: -1,
      onUpdate: function (tween) {
        spinner.setAngle(tween.getValue());
      }
    });

    this._showLoadingScreen(true);
    this._showLoadingScreen(false);
  }

  private _showLoadingScreen(show: boolean = false) {
    this._adWaitingPanelContianer.setVisible(show);
    this._adWaitingPanelContianer.setActive(show);
    this._adWaitingPanelContianer.setDepth(50);
  }

  private onShopPanel(visible: boolean = true) {
    window.constants["CAR_CHOOSEN"] = SDKManager.carEquipped;
    this._carIndex = window.constants["CAR_CHOOSEN"];
    window.constants["MAP"] = SDKManager.mapEquipped;
    this._mapIndex = window.constants["MAP"];
    // this._coins = +localStorage.getItem("hammerplay_rampageroad_coins");
    SDKManager.getPlayerCoinsMetaData();
    this._coins = SDKManager.coins;
    this._shopPanel.visible = visible;
    this._shopText.visible = visible;
    this._shopCoin.visible = visible;
    this._shopCoinsAvailableText.visible = visible;
    this._shopDisplayPanel.visible = visible;
    this._shopCarImage.visible = visible;
    this._shopPricePanel.visible = false;
    this._shopLeftArrow.visible = visible;
    this._shopRightArrow.visible = visible;
    this._shop_health_icon.visible = visible;
    this._shop_health_level_bar.visible = visible;
    for (let i = 0; i < this._shop_health_level.length; i++)
      this._shop_health_level[i].visible = false;
    this._shopEquipCoinImage.visible = visible;
    this._shopCoinsRequired.visible = visible;
    this._shopEquipButton.visible = visible;
    this._shopEquipText.visible = visible;
    this._shopInsufficientCoinsText.visible = false;
    this._shopCarsText.visible = visible;
    this._shopCarsButton.visible = visible;
    this._shopMapsText.visible = visible;
    this._shopMapsButton.visible = visible;
    this._shopCloseButton.visible = visible;
    this._shopCoinsAvailableText.setText(`${this._coins}`);

    if (visible) {
      this.onDisplayChange();
      this._shopLeftArrow.setInteractive();
      this._shopRightArrow.setInteractive();
      this._shopCarsButton.setInteractive();
      this._shopMapsButton.setInteractive();
      this._shopCloseButton.setInteractive();
      this._shopEquipButton.setInteractive();

      this._banner.disableInteractive();
      // this._tournamentButton.disableInteractive();
      // this._friendsButton.disableInteractive();
      // this._watchAdButton.disableInteractive();
      this._howToPlayButton.disableInteractive();
      this._shopCar.disableInteractive();
      this._title.visible = !visible;
      this._car.visible = !visible;
      // this._tournamentButton.visible = !visible;
      // this._friendsButton.visible = !visible;
      // this._watchAdButton.visible = !visible;
      this._howToPlayButton.visible = !visible;
      // this._rewardAdCoinText.visible = !visible;
      // this._rewardAdCoinImage.visible = !visible;
      this._coinText.visible = !visible;
      this._coinText.setText(`${SDKManager.coins}`);
      this._coinImage.visible = !visible;
      this._shopCar.visible = !visible;
      this._tapToStartButton.visible = !visible;
      this._tapToStartText.visible = !visible;
    }
  }

  private onCloseShopPanel() {
    SDKManager.getPlayerCarEquippedMetaData();
    SDKManager.getPlayerMapEquippedMetaData();
    this.onShopPanel(false);
    this._shopLeftArrow.disableInteractive();
    this._shopRightArrow.disableInteractive();
    this._shopCarsButton.disableInteractive();
    this._shopMapsButton.disableInteractive();
    this._shopCloseButton.disableInteractive();
    this._shopEquipButton.disableInteractive();

    // if (FBInstantManager.hasTournamentEnded) {
    // this._tournamentButton.setInteractive();
    // this._tournamentButton.visible = true;
    // } else {
    //   this._tournamentButton.disableInteractive();
    //   this._tournamentButton.visible = false;
    // }
    this._tapToStartButton.setInteractive();
    // this._friendsButton.setInteractive();
    // this._watchAdButton.setInteractive();
    this._howToPlayButton.setInteractive();
    this._shopCar.setInteractive();
    this._title.visible = true;
    this._car.visible = true;
    // this._friendsButton.visible = true;
    // this._watchAdButton.visible = true;
    this._howToPlayButton.visible = true;
    // this._rewardAdCoinText.visible = true;
    // this._rewardAdCoinImage.visible = true;
    this._coinText.visible = true;
    this._coinText.setText(`${SDKManager.coins}`);
    this._coinImage.visible = true;
    this._shopCar.visible = true;
    this._tapToStartButton.visible = true;
    this._tapToStartText.visible = true;
  }

  private onTapToStart() {
    HUDScene.menuScreenOpen = false;
    window.constants["CAR_CHOOSEN"] = SDKManager.carEquipped;
    window.constants["MAP"] = SDKManager.mapEquipped;
    // console.log(window.constants["CAR_CHOOSEN"], " - car choosen");
    // console.log(window.constants["MAP"], " - map choosen");

    this._tapToStartText.setText("loading...")
    this._tapToStartButton.disableInteractive();
    // this._tournamentButton.disableInteractive();
    // this._friendsButton.disableInteractive();
    // this._watchAdButton.disableInteractive();
    this._howToPlayButton.disableInteractive();
    this._shopCar.disableInteractive();
    this.initRegistry();
    setTimeout(() => {
      if (BootScene.isNewSession) {
        BootScene.isNewSession = false;;
      }
      this.changeScene();
    }, 300);
  }

  private _startMenuTween() {
    this._titleTween.play();
  }

  private _createSDMenuLayout() {
    this._optionSelected = 0;
    let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
    this._banner = this.add.image(w2, h2, "menu_banner");
    this._banner.setScale(0.87);
    this._car = this.add.image(0, 0, "title_car");
    this._title = this.add.image(0, 0, "menu_title");
    this._text1 = this.add.image(0, 0, "start_text");
    this._text2 = this.add.image(0, 0, "tut_text");
    this._highlight = this.add.sprite(0, 0, "highlight");
    this._highLightOffset = [
      - this._text1.height * 0.09,
      - this._text2.height * 0.07,
    ];


    this.anims.create({
      key: "highlight_anim",
      frames: this.anims.generateFrameNumbers("highlight", {
        start: 0,
        end: 1,
      }),
      frameRate: 3,
      repeat: -1,
      showOnStart: true
    })

    this._text1.setScale(0.7)
    this._highlight.setScale(0.7)
    this._text2.setScale(0.7)

    this._text1.setPosition(w2, h2 + (this._text1.height * 1.5));
    this._highlight.setPosition(this._text1.x, this._text1.y + this._highLightOffset[0]);
    this._text2.setPosition(w2, h2 + (this._text2.height * 2));
    this._title.setPosition(w2, -this._title.height);
    this._car.setPosition(w2, -this._car.height);

    // this._highlight.anims.play("highlight_anim");
    this._text1.setVisible(false);
    this._text2.setVisible(false);
    this._highlight.setVisible(false);

    this._createSDTweens();
  }

  private _destroyTweens() {
    this.tweens.remove(this._carTween);
    this.tweens.remove(this._titleTween);
    if (!window.constants["HD_FLAG"]) {
      this.tweens.remove(this._carTween2);
      this.tweens.remove(this._text1Tween);
      this.tweens.remove(this._text2Tween);
      this.tweens.remove(this._textTween2);
      this.tweens.remove(this._highlightTween);
    }
  }

  private _createSDTweens() {
    this._carTween = this.add.tween({
      targets: this._car,
      callbackScope: this,
      onComplete: this._onCarTweenComplete,
      y: { from: -Math.floor(this._car.height * 0.3), to: this._title.height * 0.4 },
      ease: 'Linear',
      duration: 400,
      repeat: 0,
      yoyo: false,
      paused: true
    });

    this._carTween2 = this.add.tween({
      targets: this._car,
      callbackScope: this,
      onComplete: this._onCarTween2Complete,
      y: { from: this._title.height * 0.4, to: window.constants["BASE_HEIGHT"] + Math.floor(this._car.height * 0.5) },
      ease: 'Linear',
      duration: 500,
      repeat: 0,
      yoyo: false,
      paused: true
    });


    this._titleTween = this.add.tween({
      targets: this._title,
      callbackScope: this,
      onComplete: this._onTitleTweenComplete,
      y: { from: -this._title.height, to: Math.floor(this._title.height * 0.5) },
      ease: Phaser.Math.Easing.Expo.Out,
      duration: 400,
      repeat: 0,
      yoyo: false,
      paused: true
    });

    this._text1Tween = this.add.tween({
      targets: this._text1,
      callbackScope: this,
      onStart: this._onText1TweenStart,
      onComplete: this._onText1TweenComplete,
      scale: { from: 1.8, to: 0.7 },
      ease: Phaser.Math.Easing.Expo.InOut,
      duration: 400,
      repeat: 0,
      yoyo: false,
      paused: true,
      delay: 400
    });

    this._text2Tween = this.add.tween({
      targets: this._text2,
      callbackScope: this,
      onComplete: this._onText2TweenComplete,
      scale: { from: 1.8, to: 0.7 },
      ease: Phaser.Math.Easing.Expo.InOut,
      duration: 400,
      repeat: 0,
      yoyo: false,
      paused: true
    });

    this._textTween2 = this.add.tween({
      targets: [this._text1, this._text2, this._highlight],
      callbackScope: this,
      onComplete: this._onTextTween2Complete,
      scale: { from: 0.7, to: 0 },
      ease: Phaser.Math.Easing.Expo.InOut,
      duration: 500,
      repeat: 0,
      yoyo: false,
      paused: true
    });

    this._highlightTween = this.add.tween({
      targets: this._highlight,
      alpha: { from: 0, to: 1 },
      callbackScope: this,
      onComplete: this._onHighlightTweenComplete,
      ease: Phaser.Math.Easing.Expo.Out,
      duration: 200,
      repeat: 0,
      yoyo: false,
      paused: true
    });
  }

  private _createTweens() {
    SDKManager.getPlayerCoinsMetaData();
    this._carTween = this.add.tween({
      targets: this._car,
      callbackScope: this,
      onComplete: function () {
        window.setTimeout(() => {
          this._tapToStartButton.visible = true;
          this._tapToStartText.visible = true;
          // if (FBInstantManager.hasTournamentEnded) {
          // this._tournamentButton.setInteractive();
          // this._tournamentButton.visible = true;
          // } else {
          //   this._tournamentButton.disableInteractive();
          //   this._tournamentButton.visible = false;
          // }
          // this._friendsButton.visible = true;
          // this._watchAdButton.visible = true;
          this._howToPlayButton.visible = true;
          // this._rewardAdCoinText.visible = true;
          // this._rewardAdCoinImage.visible = true;
          this._coinText.visible = true;
          this._coinText.setText(`${SDKManager.coins}`);
          this.time.delayedCall(1200, () => {
            this._coinText.setText(`${SDKManager.coins}`);
          })
          this._coinImage.visible = true;
          this._shopCar.visible = true;
          this._tapToStartButton.setInteractive();
          // this._friendsButton.setInteractive();
          // this._watchAdButton.setInteractive();
          this._howToPlayButton.setInteractive();
          this._shopCar.setInteractive();
        }, 800);
        //window.setTimeout(this.changeScene.bind(this), 300)
      },
      y: { from: -Math.floor(this._car.height * 0.3), to: Math.floor(this._car.height * 0.33) },
      ease: 'Linear',
      duration: 350,
      repeat: 0,
      yoyo: false,
      paused: true,
      delay: 100
    });

    this._titleTween = this.add.tween({
      targets: this._title,
      callbackScope: this._carTween,
      onComplete: this._carTween.play,
      y: { from: -this._title.height, to: Math.floor(this._title.height * 0.15) },
      ease: Phaser.Math.Easing.Expo.Out,
      duration: 400,
      repeat: 0,
      yoyo: false,
      paused: true
    });
  }

  private _resetMenuLayout() {
    this._tapToStartText.setText("Tap To Start");
    if (window.game.sound.volume == 1)
      window.game.sound.mute = false;
    this._audio.play();
    if (window.constants["HD_FLAG"]) {
      this._resetMenu();
    } else {
      this._resetSDMenu();
    }
  }

  private _resetMenu() {
    let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
    this._title.setPosition(w2, -this._title.height);
    this._car.setPosition(w2, -this._car.height);
    this._destroyTweens();
    this._createTweens();

    this._titleTween.play();
  }

  private _resetSDMenu() {
    let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
    this._text1.setPosition(w2, h2 + (this._text1.height * 1.5));
    this._highlight.setPosition(this._text1.x, this._text1.y + this._highLightOffset[0]);
    this._text2.setPosition(w2, h2 + (this._text2.height * 2));
    this._title.setPosition(w2, -this._title.height);
    this._car.setPosition(w2, -this._car.height);

    this._text1.setScale(0.7)
    this._highlight.setScale(0.7)
    this._text2.setScale(0.7)

    // this._highlight.anims.play("highlight_anim");
    this._text1.setVisible(false);
    this._text2.setVisible(false);
    this._highlight.setVisible(false);

    this._optionSelected = 0;

    this.input.keyboard.removeListener("keyup", this._selectOption, this);
    this._destroyTweens();
    this._createSDTweens();

    this._titleTween.play();
  }

  private _resetPlaceHolderMenu() {
    this.input.removeListener("pointerup", this._onTouchUp, this);
    this.input.addListener("pointerup", this._onTouchUp, this);
  }

  private _onCarTweenComplete() {
    this._text1Tween.play();
    // this._titleTween.play();
  }

  private _onCarTween2Complete() {
    this.changeScene();
  }

  private _onText1TweenStart() {
    this._text1.setVisible(true);
    this._highlight.setVisible(false);
    this._highlightTween.pause();
  }
  private _onTitleTweenComplete() {
    this._carTween.play();
  }

  private _onTextTween2Complete() {
    this._carTween2.play();
  }

  private _onText1TweenComplete() {
    this._text2.setVisible(true);
    this._text2Tween.play();
  }

  private _onText2TweenComplete() {
    this._highlight.setVisible(true);
    this._highlightTween.play();
  }

  private _onHighlightTweenComplete() {
    this._highlight.anims.play("highlight_anim");

    if (window.constants["HD_FLAG"]) {
      // this._text1.setInteractive( null, this._onOptionTouch.bind(this, ));
      // this._text2.setInteractive();
      // this.input.addListener("pointerup", this._selectOption, this);
      // this.input.addListener("pointerup", this._selectOption, this);
    } else {
      this.input.keyboard.addListener("keyup", this._selectOption, this);
    }
  }

  private _selectOption(e) {
    switch (e.which) {
      case 13:
        window.constants["TUTORIAL_MODE"] = (!!this._optionSelected);
        this._textTween2.play();
        break;
      case 38:
        this._optionSelected = 0;
        this._highlight.setPosition(this._text1.x, this._text1.y + this._highLightOffset[0]);
        break;
      case 40:
        this._optionSelected = 1;
        this._highlight.setPosition(this._text2.x, this._text2.y + this._highLightOffset[1]);
        break;
    }
  }

  private _createPlaceHolderMenu() {
    let fontSize, text;
    if (window.constants["HD_FLAG"]) {
      fontSize = 40;
      text = "Tap To Play";
    }
    else {
      fontSize = 10;
      text = "Press 5 To Play";
    }
    this.bitmapTexts = [];
    this.bitmapTexts.push(
      this.add.text(
        this.sys.canvas.width / 2,
        this.sys.canvas.height / 2,
        text,
        { fontSize: fontSize, fontFamily: 'font_3' }
      )
    );

    this.bitmapTexts.push(
      this.add.text(
        this.sys.canvas.width / 2,
        this.sys.canvas.height / 2,
        "rampage road",
        { fontSize: fontSize, fontFamily: 'font_3' }
      )
    );

    this.bitmapTexts[0].setOrigin(0.5);
    this.bitmapTexts[1].setOrigin(0.5);
    this.bitmapTexts[0].y = this.bitmapTexts[0].y - (this.bitmapTexts[0].height * 2);
    this.bitmapTexts[1].y = this.bitmapTexts[0].y + (this.bitmapTexts[0].height * 2);

    if (this.input.keyboard) {
      this.input.keyboard.removeListener("keyup", this._onKeyUp, this);
      this.input.keyboard.addListener("keyup", this._onKeyUp, this);
    } else {
      this.input.removeListener("pointerup", this._onTouchUp, this);
      this.input.addListener("pointerup", this._onTouchUp, this);
    }
  }

  create(): void {

  }

  update(time, dt): void {

  }

  destroy() {
  }

  private changeScene() {
    this._audio.stop();
    // if (FBInstantManager.isTournament)
    //   FBInstantManager.canSetTournamentGameOver = true;
    // else
    //   FBInstantManager.canSetTournamentGameOver = false;
    this.scene.switch("HUDScene");
    this.scene.switch("GameScene");
    this.scene.get("HUDScene").events.emit("resumeGame");
    this.scene.bringToTop("HUDScene");
  }

  /**
   * Build-in global game data manager to exchange data between scenes.
   * Here we initialize our variables with a key.
   */
  private initRegistry(): void {
    this.registry.set("points", 0);
    switch (window.constants["CAR_CHOOSEN"]) {
      case 0:
        this.registry.set("health", 10);
        break;
      case 1:
        this.registry.set("health", 11);
        break;
      case 2:
        this.registry.set("health", 11);
        break;
      case 3:
        this.registry.set("health", 12);
        break;
      case 4:
        this.registry.set("health", 12);
        break;
      case 5:
        this.registry.set("health", 13);
        break;
      case 6:
        this.registry.set("health", 13);
        break;
    }
    this.registry.set("level", 1);
  }
}
